import styles from "./Forms.module.css";
import Form from "./Form.jsx";

function Forms() {
  return (
    <div className={styles.wrapper}>
      <Form />
    </div>
  );
}

export default Forms;
